import React from 'react';
import ReactMarkdown from 'react-markdown';

export const MarkdownDisplay = ({text, plugins}) => {

    return (
        <ReactMarkdown rehypePlugins={plugins}>{text}</ReactMarkdown>
    )
}
